import { type FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DragDropContext } from 'react-beautiful-dnd';
import DelayedDroppableWrapper from '@editor2/components/DelayedDroppableWrapper';

import { movePage } from '@editor2/reducers/editor/editorSlice';
import { type RootState } from '@editor2/reducers/root';
import { contentBlock } from '@editor2/containers/PageGroupPage/styles';
import Page from './Page';

interface Props {
	pageGroupId: string;
	chapterId: string;
	courseId: number;
}

const PagesList: FC<Props> = (props) => {
	const { pageGroupId, chapterId, courseId } = props;

	const dispatch = useDispatch();
	const { page_groups } = useSelector((state: RootState) => state.courses[courseId]);
	const pageGroupPages = page_groups.entities[pageGroupId].pages;

	const onDragEnd = (result) => {
		const { source, destination, draggableId, type } = result;
		const { droppableId: sourceDroppableId } = source;
		const { droppableId: destinationDroppableId, index: destinationIndex } = destination;

		if (type === 'Page') {
			dispatch(
				movePage({
					sourceDroppableId,
					destinationDroppableId,
					destinationIndex,
					pageId: draggableId,
					courseId
				})
			);
		}
	};

	return (
		<div className={contentBlock}>
			<DragDropContext onDragEnd={onDragEnd}>
				<DelayedDroppableWrapper droppableId={pageGroupId} type="Page">
					{(provided) => (
						<div ref={provided.innerRef} {...provided.droppableProps}>
							{pageGroupPages.map((pageId, index) => (
								<Page
									pageId={pageId}
									pageGroupId={pageGroupId}
									chapterId={chapterId}
									courseId={courseId}
									index={index}
									key={pageId}
								/>
							))}
							{provided.placeholder}
						</div>
					)}
				</DelayedDroppableWrapper>
			</DragDropContext>
		</div>
	);
};

export default PagesList;
